import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Container, Row, NavLink} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger, Flip } from "gsap/all";
import { bloggerPageDetails } from '../types/bloggerServices';
import { getPage } from '../services/blogger';
import SocialLinks from '../UI/Card/SocialLinks';



gsap.registerPlugin(ScrollTrigger, Flip, useGSAP);


export default function GetInvolvedTemplate() {
    const bloggerPageID = '3701142784994968498';
    const [page, setPage] = useState<bloggerPageDetails>();
    const [loaded, setLoaded] = useState<boolean>();
    const getData = async () => {
        setLoaded(false);
        try{
          const response = await getPage(bloggerPageID);
          console.log(response)
          setPage(response)
        }
        catch(e){
          console.log(e);
        }
        finally{
            setLoaded(true)
        }
      }
    
      useEffect(() => {
        getData()
      }, []);

  return (
   <div className='route-container-fullpage getInvolved-wrapper'>
      <Container fluid className='getInvolved-hero'>
          <Row >
              <Col className='getInvolved-hero-text'>
                  <h1>የለውጡ ተሳታፊ ይሁኑ</h1>
                  <Button href={'#join-call-to-action'} className='glass-button'>Join The Change</Button>
              </Col>
          </Row>

      </Container>
     <Container id="join-call-to-action">
        <Row>
            <Col>
                <h1>{page?.title}</h1>
            </Col>
        </Row>
        <Row>
            {page?.content ? <div dangerouslySetInnerHTML={{ __html: page.content }} />: <h1>Loading ... </h1>}
        
        </Row>
        <Row>
          <Col>
            <SocialLinks header='ለበለጠ መረጃ በማህበራዊ ገፆቻችን ላይ ወይም በ info@fattehmagazine.com ፃፉልን።'/>
          </Col>
        </Row>
    </Container>
   </div>
  );
}
